<div class="d-flex flex-column h-100 w-100 align-items-center justify-content-center">
    <h1>404</h1>
    <p>The page you are looking for does not exist. But you can click the button below to go back to the homepage.</p>
    <a class="text-white" ng-reflect-router-link="/" href="/" class="btn bg-voilet text-white px-3 py-2">Home</a>
</div>